module.exports = __webpack_public_path__ + "fonts/futura-heavy-bt.074a76d5.ttf";